import { useSearchParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';
import dayjs from 'dayjs';
import { useUIDateFormat } from './use-ui-dateFormat';

const END_DATE_FIELD_MAP: Record<string, string> = {
  StartDate: 'EndDate',
  startDate: 'endDate',
  CreatedAtFrom: 'CreatedAtTo',
  DateFrom: 'DateTo',
};

/**
 * Сбросить фильтры (в урл и форме)
 * @param preserveDates - если true, устанавливает "от" = вчера, "до" = сегодня, иначе полный сброс
 */
export const useResetFormAndUrlFilters = (preserveDates: boolean = false) => {
  const [, setParams] = useSearchParams();
  const { reset, getValues } = useFormContext();
  const dateFormat = useUIDateFormat();
  
  return useCallback(() => {
    if (preserveDates) {
      const yesterday = dayjs().subtract(1, 'day').format(dateFormat);
      const today = dayjs().format(dateFormat);
      const currentValues = getValues();
      
      const startField = 'StartDate' in currentValues ? 'StartDate' :
                        'startDate' in currentValues ? 'startDate' :
                        'CreatedAtFrom' in currentValues ? 'CreatedAtFrom' :
                        'DateFrom' in currentValues ? 'DateFrom' : null;
      const endField = startField ? END_DATE_FIELD_MAP[startField] : null;
      
      const params = new URLSearchParams();
      if (startField) {
        params.set(startField, yesterday);
      }
      if (endField) {
        params.set(endField, today);
      }
      setParams(params);
      
      const resetValues: Record<string, any> = { ...currentValues };
      
      Object.keys(resetValues).forEach(key => {
        if (key === startField) {
          resetValues[key] = yesterday;
        } else if (key === endField) {
          resetValues[key] = today;
        } else if (Array.isArray(resetValues[key])) {
          resetValues[key] = [];
        } else if (typeof resetValues[key] === 'string') {
          resetValues[key] = '';
        } else {
          resetValues[key] = null;
        }
      });
      
      reset(resetValues);
    } else {
      setParams(new URLSearchParams());
      reset();
    }
  }, [reset, setParams, getValues, dateFormat, preserveDates]);
};
